import { render, staticRenderFns } from "./ModelDocs.vue?vue&type=template&id=259b3102"
import script from "./ModelDocs.vue?vue&type=script&lang=js"
export * from "./ModelDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports